import { Input, Label } from '@creanizer/ui'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@creanizer/ui'
import type { ItemInput } from '@creanizer/types'
import { ItemFormAdvanced } from './ItemFormAdvanced'

interface ItemFormSettingsProps {
  input: ItemInput
  onChange: (input: ItemInput) => void
  useStreaming?: boolean
  onStreamingChange?: (value: boolean) => void
  mode?: ItemInput['mode']
  hasWorldContext?: boolean
}

export function ItemFormSettings({ input, onChange, useStreaming, onStreamingChange, mode, hasWorldContext }: ItemFormSettingsProps) {
  return (
    <div className="space-y-4">
      {/* レア度 - バッチモード時は非表示 */}
      {mode !== 'batch' && (
        <div>
          <Label htmlFor="rarity">レア度</Label>
          <Select
            value={input.rarity || 'common'}
            onValueChange={(value) => onChange({ ...input, rarity: value as ItemInput['rarity'] })}
          >
            <SelectTrigger>
              <SelectValue placeholder="レア度を選択" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="common">コモン</SelectItem>
              <SelectItem value="uncommon">アンコモン</SelectItem>
              <SelectItem value="rare">レア</SelectItem>
              <SelectItem value="epic">エピック</SelectItem>
              <SelectItem value="legendary">レジェンダリー</SelectItem>
              <SelectItem value="mythic">ミシック</SelectItem>
              <SelectItem value="unique">ユニーク</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}

      {/* ジャンル - 世界観選択時は非表示 */}
      {!hasWorldContext && (
        <div>
          <Label htmlFor="genre">ジャンル</Label>
          <Select
            value={input.genre || 'fantasy'}
            onValueChange={(value) => onChange({ ...input, genre: value as ItemInput['genre'] })}
          >
            <SelectTrigger>
              <SelectValue placeholder="ジャンルを選択" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="fantasy">ファンタジー</SelectItem>
              <SelectItem value="sf">SF</SelectItem>
              <SelectItem value="modern">現代</SelectItem>
              <SelectItem value="post_apocalypse">ポストアポカリプス</SelectItem>
              <SelectItem value="cyberpunk">サイバーパンク</SelectItem>
              <SelectItem value="steampunk">スチームパンク</SelectItem>
              <SelectItem value="mythology">神話</SelectItem>
              <SelectItem value="horror">ホラー</SelectItem>
              <SelectItem value="urban_fantasy">アーバンファンタジー</SelectItem>
              <SelectItem value="custom">カスタム</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}

      {!hasWorldContext && input.genre === 'custom' && (
        <div>
          <Label htmlFor="customGenre">カスタムジャンル</Label>
          <Input
            id="customGenre"
            placeholder="独自のジャンルを入力"
            value={input.customGenre || ''}
            onChange={(e) => onChange({ ...input, customGenre: e.target.value })}
          />
        </div>
      )}

      {/* 詳細設定を別コンポーネントに分離 */}
      <ItemFormAdvanced 
        input={input} 
        onChange={onChange} 
        useStreaming={useStreaming}
        onStreamingChange={onStreamingChange}
        hasWorldContext={hasWorldContext}
      />
    </div>
  )
}